import { useMutation } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';
import { CodelistRecord } from 'features/codelist/domain/codelistRecordSchema';

type ImportCodelistRecordsArgs = {
	identifyingVariableName: string;
	records: CodelistRecord[];
	projectId: string;
};

type ImportCodelistRecordsResponse = { importedCount: number; skippedCount: number };

const importBulkCodelistRecords = async (args: ImportCodelistRecordsArgs) => {
	return makeRequest<ImportCodelistRecordsResponse>({
		service: 'cde',
		method: 'importBulkCodelistRecords',
		data: {
			records: args.records,
			identifyingVariableName: args.identifyingVariableName,
			projectId: args.projectId
		}
	});
};

const partialImportCodelistRecords = async (args: ImportCodelistRecordsArgs) => {
	return makeRequest<ImportCodelistRecordsResponse>({
		service: 'cde',
		method: 'partialImportCodelistRecords',
		data: {
			records: args.records,
			identifyingVariableName: args.identifyingVariableName,
			projectId: args.projectId
		}
	});
};

export const useImportBulkCodelistRecordsMutation = () => {
	return useMutation({
		mutationFn: importBulkCodelistRecords
	});
};

export const usePartialImportCodelistRecordsMutation = () => {
	return useMutation({
		mutationFn: partialImportCodelistRecords
	});
};
